import { render, staticRenderFns } from "./SampleClassificationChemical.vue?vue&type=template&id=5cf86e4c&scoped=true"
import script from "./SampleClassificationChemical.vue?vue&type=script&lang=js"
export * from "./SampleClassificationChemical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf86e4c",
  null
  
)

export default component.exports